import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { LoginService } from 'src/app/auth/login.service';
import { HeaderService } from 'src/app/core/services/header.service';
import { StockService } from 'src/app/core/services/stock.service';
import { AuthDialogComponent } from 'src/app/shared/components/auth-dialog/auth-dialog.component';
import { environment } from 'src/environments/environment';

interface Buyer {
  user_id: number;
  user_code: string;
}

interface StockDetailItem {
  id?: number | null;
  name: string;
  type?: string;
  unit?: string;
  quantity?: number | null;
  soldQty?: number | null;
  retailPrice?: number | null;
  wholesaleTotal?: number | null;
  note?: string;
  existingImages?: string[];
  isActive?: boolean;
  isChecked?: boolean;
  buyers?: Buyer[];
  revenue?: number | null;
  profit?: number | null;

}

interface PreviewItem {
  preview: string;
  name: string;
  type: string;
}

@Component({
  selector: 'app-stock-detail-modal',
  templateUrl: './stock-detail-modal.component.html',
  styleUrls: ['./stock-detail-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StockDetailModalComponent implements OnDestroy, OnInit {
  @Input() isAdmin = false;

  @Input() openFrom: 'userstock' | 'medialist' = 'medialist';

  @Output() contractSigned = new EventEmitter<any>();

  @ViewChild(AuthDialogComponent) authDialog?: AuthDialogComponent;

  isVisible = false;
  isContractModalVisible = false;
  loadingDetail = false;
  signing = false;
  errorMessage = '';

  detailData: {
    id: number | null;
    title: string;
    warehouseName: string;
    description: string;
    totalRevenue?: number | null;
    totalWholesale?: number | null;
    totalProfit?: number | null;
    items: StockDetailItem[];
    stockOwnerId?: number | null;
  } = {
      id: null,
      title: 'KẾ HOẠCH KINH DOANH',
      warehouseName: 'TỔNG KHO MỸ PHẨM NỘI ĐỊA',
      description: '',
      items: [],
      stockOwnerId: null,
    };

  existingMediaByItem: string[][] = [];
  activePreviewIndexByItem: number[] = [];
  selectedItemIndexes: boolean[] = [];
  userCode = '';
  private pendingContractOpen = false;

  contractContent = {
    title: 'CAM KẾT GIAO DỊCH ĐIỆN TỬ',
    commitment: [
      'Người mua thực hiện giao dịch thông qua tài khoản trên nền tảng do Bên cung cấp quản lý. Việc nhấn xác nhận mua, thanh toán hoặc sử dụng dịch vụ được xem là hành vi xác lập hợp đồng điện tử.',
      'Người mua cam kết sử dụng tài khoản hợp pháp, thanh toán đầy đủ giá trị giao dịch và chịu trách nhiệm đối với mọi hoạt động phát sinh từ tài khoản của mình.',
      'Mọi dữ liệu giao dịch, lịch sử hệ thống và thông tin tài khoản được lưu trữ trên nền tảng có giá trị là bằng chứng xác nhận giao dịch.',
      'Bên cung cấp có quyền từ chối giao dịch hoặc tạm ngưng, khóa tài khoản khi phát hiện hành vi gian lận hoặc vi phạm quy định.',
      'Cam kết này có hiệu lực kể từ thời điểm người mua thực hiện giao dịch trên nền tảng và được lưu trữ dưới dạng dữ liệu điện tử theo quy định của pháp luật.',
    ],
    projectTitle: 'MỤC LỤC QUAN TRỌNG CỦA DỰ ÁN',
    projectSubtitle: 'Hợp tác đại lý bán lẻ trong hệ thống gian hàng thương mại',
    projectSections: [
      {
        title: '1. Mục tiêu của dự án',
        paragraphs: [
          'Dự án được xây dựng nhằm kết nối nền tảng thương mại điện tử với hệ thống đại lý bán lẻ, tạo ra một mô hình phân phối hàng hóa linh hoạt và hiệu quả.',
          'Mục tiêu chính của dự án bao gồm:',
        ],
        bullets: [
          'Tăng tốc độ sản xuất và phân phối hàng hóa ra thị trường.',
          'Tạo cơ hội cho các đại lý bán lẻ tham gia vào chuỗi cung ứng ngay từ giai đoạn đầu.',
          'Hình thành hệ sinh thái thương mại điện tử có tốc độ xử lý hàng hóa nhanh và ổn định.',
          'Gia tăng hiệu suất phát triển của ngành trong lĩnh vực thương mại điện tử (TMĐT).',
        ],
      },
      {
        title: '2. Vì sao chúng tôi cần các đại lý tham gia',
        paragraphs: [
          'Trong mô hình kinh doanh truyền thống, quá trình sản xuất và phân phối thường diễn ra theo nhiều tầng trung gian, khiến:',
        ],
        bullets: [
          'Thời gian đưa sản phẩm ra thị trường chậm.',
          'Tốc độ luân chuyển hàng hóa thấp.',
          'Khả năng mở rộng thị trường bị hạn chế.',
        ],
        paragraphs2: [
          'Vì vậy, dự án được triển khai với mục tiêu hợp tác trực tiếp với các đại lý bán lẻ, giúp:',
        ],
        bullets2: [
          'Đẩy nhanh tiến độ phân phối hàng hóa.',
          'Tăng khả năng tiêu thụ sản phẩm trong thời gian ngắn.',
          'Tối ưu hóa chuỗi cung ứng trong hệ thống TMĐT.',
          'Tạo cơ hội cho đại lý tham gia kinh doanh và tạo lợi nhuận từ giai đoạn đầu của chuỗi phân phối.',
        ],
      },
      {
        title: '3. Vai trò của đại lý trong hệ thống',
        paragraphs: ['Các đại lý bán lẻ đóng vai trò quan trọng trong việc:'],
        bullets: [
          'Tham gia mua các kho hàng có sẵn trên nền tảng.',
          'Thực hiện bán và phân phối hàng hóa ra thị trường.',
          'Góp phần thúc đẩy tốc độ lưu thông hàng hóa trong hệ thống.',
          'Hỗ trợ mở rộng mạng lưới phân phối trên thị trường TMĐT.',
        ],
        paragraphs2: [
          'Sự tham gia của đại lý giúp hệ thống tăng khả năng xử lý hàng hóa nhanh hơn và ổn định hơn.',
        ],
      },
      {
        title: '4. Lợi ích dành cho đại lý tham gia',
        paragraphs: [
          'Khi tham gia dự án, các đại lý bán lẻ có thể nhận được những lợi ích sau:',
        ],
        bullets: [
          'Tiếp cận nguồn hàng có sẵn từ nền tảng.',
          'Không cần trực tiếp quản lý toàn bộ quy trình sản xuất.',
          'Có thể tham gia vào chuỗi phân phối ngay từ giai đoạn đầu.',
          'Tận dụng hệ thống vận hành và công cụ bán hàng từ nền tảng.',
        ],
        paragraphs2: [
          'Ngoài ra, đại lý có thể tạo lợi nhuận từ quá trình bán và phân phối hàng hóa theo sự tăng trưởng của thị trường và ngành TMĐT.',
        ],
      },
      {
        title: '5. Cơ chế hợp tác trong dự án',
        paragraphs: ['Cơ chế hoạt động của dự án được xây dựng dựa trên các bước sau:'],
        bullets: [
          'Đại lý đăng ký tài khoản trên nền tảng.',
          'Đại lý lựa chọn và mua các kho hàng có sẵn.',
          'Sau khi hoàn tất giao dịch, quyền sở hữu kho hàng thuộc về đại lý.',
          'Đại lý thực hiện việc bán hàng trong thời gian từ 2 đến 7 ngày kể từ khi mua kho hàng.',
        ],
        paragraphs2: [
          'Quy trình này giúp đảm bảo tốc độ lưu thông hàng hóa nhanh và hiệu quả.',
        ],
      },
      {
        title: '6. Tác động đối với sự phát triển của ngành',
        paragraphs: ['Thông qua việc kết hợp giữa:'],
        bullets: [
          'Nền tảng công nghệ',
          'Hệ thống kho hàng',
          'Mạng lưới đại lý bán lẻ',
        ],
        paragraphs2: ['Dự án hướng đến mục tiêu:'],
        bullets2: [
          'Tăng hiệu suất xử lý hàng hóa trong hệ thống TMĐT.',
          'Tăng tốc độ sản xuất và phân phối.',
          'Góp phần thúc đẩy sự phát triển chung của ngành thương mại điện tử.',
        ],
      },
    ],
    regulationTitle: 'QUY CHẾ HOẠT ĐỘNG',
    regulationSubtitle: 'Nền tảng Gian hàng Thương mại dành cho Đại lý Bán lẻ',
    regulations: [
      {
        title: 'Điều 1. Mục đích dự án',
        bullets: [
          'Thiết lập hệ thống kinh doanh dựa trên nền tảng thương mại, kết nối giữa nền tảng cung cấp kho hàng và đại lý bán lẻ.',
          'Tạo cơ hội cho đại lý bán lẻ tiếp cận nguồn hàng có sẵn trên nền tảng, tối ưu tốc độ bán hàng và luân chuyển hàng hóa.',
          'Đảm bảo hoạt động kinh doanh minh bạch, hiệu quả và tuân thủ các quy định của nền tảng.',
        ],
      },
      { title: 'PHẦN I - QUY ĐỊNH THAM GIA NỀN TẢNG', isSection: true },
      {
        title: 'Điều 2. Đối tượng tham gia',
        bullets: [
          'Cá nhân hoặc tổ chức hoạt động trong lĩnh vực bán lẻ.',
          'Đại lý có nhu cầu kinh doanh hàng hóa thông qua hệ thống kho hàng của nền tảng.',
          'Người dùng đăng ký tài khoản và chấp thuận quy chế hoạt động của nền tảng.',
        ],
      },
      {
        title: 'Điều 3. Mở tài khoản trên nền tảng',
        bullets: [
          'Đại lý bán lẻ phải đăng ký tài khoản chính thức trên nền tảng để tham gia dự án.',
          'Mỗi đại lý chỉ được phép sử dụng 01 tài khoản chính để quản lý hoạt động mua bán.',
          'Đại lý có trách nhiệm cung cấp thông tin chính xác, bảo mật tài khoản và mật khẩu, không chia sẻ quyền truy cập cho bên thứ ba nếu chưa được sự cho phép của nền tảng.',
        ],
      },
      { title: 'PHẦN II - QUY ĐỊNH VỀ MUA KHO HÀNG', isSection: true },
      {
        title: 'Điều 4. Cơ chế kho hàng',
        bullets: [
          'Nền tảng cung cấp các kho hàng đã được chuẩn bị sẵn với số lượng và danh mục cụ thể.',
          'Đại lý bán lẻ có thể mua kho hàng trực tiếp trên nền tảng theo giá được công bố.',
        ],
      },
      {
        title: 'Điều 5. Quyền sở hữu kho hàng',
        bullets: [
          'Sau khi đại lý hoàn tất giao dịch mua kho hàng trên nền tảng, quyền sở hữu kho hàng sẽ thuộc về đại lý bán lẻ.',
          'Đại lý có toàn quyền phân phối và bán hàng theo quy định của nền tảng.',
        ],
      },
      {
        title: 'Điều 6. Cam kết bán hàng',
        bullets: [
          'Đại lý bán lẻ cam kết bán hết kho hàng trong thời gian từ 2 đến 7 ngày kể từ thời điểm mua kho hàng.',
          'Nền tảng có thể hỗ trợ hệ thống khách hàng, công cụ marketing, hệ thống quản lý bán hàng.',
          'Đại lý có trách nhiệm chủ động trong việc tìm kiếm khách hàng và thực hiện bán hàng.',
        ],
      },
      { title: 'PHẦN III - CƠ CHẾ LỢI NHUẬN', isSection: true },
      {
        title: 'Điều 7. Nguyên tắc lợi nhuận',
        bullets: [
          'Lợi nhuận của đại lý bán lẻ được hình thành từ sự tăng trưởng giá trị của ngành và thị trường.',
          'Giá trị hàng hóa và lợi nhuận có thể thay đổi tùy theo cung cầu thị trường, sự phát triển của ngành, chính sách kinh doanh của nền tảng.',
        ],
      },
      {
        title: 'Điều 8. Chính sách phân chia lợi nhuận',
        bullets: [
          'Đại lý bán lẻ hưởng lợi nhuận từ việc bán kho hàng đã mua.',
          'Nền tảng có thể điều chỉnh chính sách lợi nhuận để phù hợp với thị trường và chiến lược phát triển.',
        ],
      },
      { title: 'PHẦN IV - QUY ĐỊNH TUÂN THỦ CỦA ĐẠI LÝ', isSection: true },
      {
        title: 'Điều 9. Tuân thủ quy định nền tảng',
        bullets: [
          'Không sử dụng nền tảng cho mục đích gian lận hoặc vi phạm pháp luật.',
          'Không thực hiện các hành vi gây ảnh hưởng đến uy tín của nền tảng.',
          'Không thao túng giá hoặc gây rối loạn thị trường.',
          'Tuân thủ chính sách bán hàng và quy trình vận hành của nền tảng.',
        ],
      },
      {
        title: 'Điều 10. Quy định về hành vi bị cấm',
        bullets: [
          'Sử dụng nhiều tài khoản nhằm trục lợi.',
          'Cung cấp thông tin sai lệch.',
          'Lôi kéo hoặc chuyển hướng khách hàng ra khỏi hệ thống nền tảng.',
          'Thực hiện các hành vi gian lận trong giao dịch.',
        ],
      },
      { title: 'PHẦN V - GIÁM SÁT VÀ XỬ LÝ VI PHẠM', isSection: true },
      {
        title: 'Điều 11. Quyền kiểm soát của nền tảng',
        bullets: [
          'Kiểm tra hoạt động của tài khoản đại lý.',
          'Theo dõi giao dịch và lịch sử mua kho hàng.',
          'Tạm khóa tài khoản khi phát hiện dấu hiệu vi phạm.',
        ],
      },
      {
        title: 'Điều 12. Hình thức xử lý vi phạm',
        bullets: [
          'Cảnh cáo.',
          'Tạm đình chỉ tài khoản.',
          'Hủy quyền tham gia dự án.',
          'Chấm dứt hợp tác.',
        ],
      },
      { title: 'PHẦN VI - ĐIỀU KHOẢN CHUNG', isSection: true },
      {
        title: 'Điều 13. Hiệu lực',
        bullets: [
          'Quy chế này có hiệu lực kể từ ngày được công bố trên nền tảng.',
          'Khi đăng ký tài khoản và tham gia dự án, đại lý mặc nhiên đồng ý với toàn bộ quy chế hoạt động.',
        ],
      },
    ],
  };

  constructor(
    private cdr: ChangeDetectorRef,
    private stockService: StockService,
    private loginService: LoginService,
    private headerService: HeaderService,
  ) { }

  ngOnInit(): void {
    this.userCode = (this.loginService.getUserCode() || '').toLowerCase();
  }

  ngOnDestroy(): void {
    document.body.classList.remove('overflow-hidden');
  }

  get isAdminUser(): boolean {
    return this.userCode === 'admin';
  }

  get isLoggedIn(): boolean {
    return !!this.userCode;
  }

  isCurrentUserOwner(item: StockDetailItem): boolean {
    if (!this.userCode || !Array.isArray(item?.buyers) || item.buyers.length === 0) {
      return false;
    }
    return item.buyers.some(buyer => buyer.user_code?.toLowerCase() === this.userCode);
  }

  get canShowContractButton(): boolean {
    return !this.isAdminUser;
  }

  get contractButtonLabel(): string {
    return this.isLoggedIn ? 'Ký hợp đồng' : 'Đăng nhập để ký';
  }

  get isContractDisabled(): boolean {
    const userCode = this.loginService.getUserCode();
    if (!userCode) return true;
    if (userCode === 'admin') return true;

    const hasSelected = (this.detailData.items || []).some(i => i.isChecked);
    const hasValidQty = (this.detailData.items || [])
      .filter(i => i.isChecked)
      .every(i => i.quantity && i.quantity > 0);

    return !hasSelected || !hasValidQty;
  }

  open(stockId?: number, source: 'userstock' | 'medialist' = 'medialist'): void {
    this.openFrom = source;

    this.isVisible = true;
    this.errorMessage = '';
    this.loadingDetail = false;
    this.signing = false;
    this.isContractModalVisible = false;

    document.body.classList.add('overflow-hidden');

    if (stockId) {
      this.loadData(stockId);
    } else {
      this.resetDetailData();
      this.cdr.markForCheck();
    }
  }

  private loadData(stockId: number): void {
    this.loadingDetail = true;
    this.errorMessage = '';
    this.cdr.markForCheck();
    const isFromUserStock = this.openFrom === 'userstock';
    this.stockService.getStock(stockId).subscribe({
      next: (res: any) => {
        const data = res?.data || {};
        const productItems: StockDetailItem[] = Array.isArray(data?.items) ? data.items : [];

        this.detailData = {
          id: data?.id ?? stockId,
          title: data?.title ?? 'KẾ HOẠCH KINH DOANH',
          warehouseName: data?.warehouseName ?? 'TỔNG KHO MỸ PHẨM NỘI ĐỊA',
          description: data?.description ?? '',
          totalRevenue: data?.totalRevenue ?? null,
          totalWholesale: data?.totalWholesale ?? null,
          totalProfit: data?.totalProfit ?? null,
          stockOwnerId: data?.userId ?? null,
          items: productItems.map((item: any) => {
            let buyers: Buyer[] = [];
            if (item?.buyers) {
              try {
                buyers = typeof item.buyers === 'string' ? JSON.parse(item.buyers) : item.buyers;
              } catch (e) {
                console.warn('Failed to parse buyers:', item.buyers);
                buyers = [];
              }
            }
            return {
              id: item?.id ?? null,
              name: item?.name ?? '',
              type: item?.type ?? '',
              unit: item?.unit ?? 'sản phẩm',
              isActive: !!item?.isActive,
              isChecked: false,
              quantity: isFromUserStock ? (item?.quantity ?? 1) : null,
              soldQty: item?.soldQty ?? null,
              retailPrice: item?.retailPrice ?? null,
              wholesaleTotal: item?.wholesaleTotal ?? null,
              note: item?.note ?? '',
              existingImages: Array.isArray(item?.existingImages) ? item.existingImages : [],
              buyers: buyers,
              revenue: item?.revenue ?? null,
              profit: item?.profit ?? null,
            };
          }),
        };

        this.existingMediaByItem = (this.detailData.items || []).map((item) =>
          (Array.isArray(item?.existingImages) ? item.existingImages : [])
            .filter((path: string) => !!path)
            .map((path: string) => this.buildImageUrl(path))
        );

        this.activePreviewIndexByItem = this.detailData.items.map(() => 0);
        this.selectedItemIndexes = this.detailData.items.map(() => false);

        this.loadingDetail = false;
        this.cdr.markForCheck();
      },
      error: (err) => {
        console.error('Không thể tải dữ liệu chi tiết kho:', err);
        this.errorMessage = 'Không thể tải dữ liệu. Vui lòng thử lại.';
        this.loadingDetail = false;
        this.resetDetailData();
        this.cdr.markForCheck();
      },
    });
  }

  private resetDetailData(): void {
    this.detailData = {
      id: null,
      title: 'KẾ HOẠCH KINH DOANH',
      warehouseName: 'TỔNG KHO MỸ PHẨM NỘI ĐỊA',
      description: '',
      items: [],
    };
    this.existingMediaByItem = [];
    this.activePreviewIndexByItem = [];
    this.selectedItemIndexes = [];
  }

  isItemSelected(itemIndex: number): boolean {
    return !!this.selectedItemIndexes[itemIndex];
  }

  toggleItemSelection(itemIndex: number): void {
    this.selectedItemIndexes[itemIndex] = !this.selectedItemIndexes[itemIndex];
    this.cdr.markForCheck();
  }

  close(): void {
    this.isVisible = false;
    this.isContractModalVisible = false;
    this.errorMessage = '';
    this.loadingDetail = false;
    this.signing = false;
    document.body.classList.remove('overflow-hidden');
    this.cdr.markForCheck();
  }

  openContractModal(): void {
    if (this.isAdminUser) {
      return;
    }

    if (!this.isLoggedIn) {
      this.pendingContractOpen = true;
      this.authDialog?.open('login');
      return;
    }

    this.isContractModalVisible = true;
    document.body.classList.add('overflow-hidden');
    this.cdr.markForCheck();
  }

  handleContractClick(): void {
    if (this.isContractDisabled) return;

    const filteredItems = (this.detailData.items || []).filter(item => item.isChecked);

    if (filteredItems.length < 1) {
      alert('Vui lòng chọn ít nhất một kho hàng để ký hợp đồng.');
      return;
    }

    const invalidItems = filteredItems.filter(item =>
      !item.quantity || item.quantity <= 0
    );

    if (invalidItems.length > 0) {
      alert('Vui lòng nhập số lượng cho tất cả kho hàng đã chọn.');
      return;
    }

    this.openContractModal();
  }

  handleAuthLoggedIn(): void {
    this.userCode = (this.loginService.getUserCode() || '').toLowerCase();
    this.headerService.requestRefresh();
    if (this.pendingContractOpen) {
      this.pendingContractOpen = false;
      this.openContractModal();
    }
  }

  closeContractModal(): void {
    this.isContractModalVisible = false;
    if (this.isVisible) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
    this.cdr.markForCheck();
  }

  signContract(): void {
    if (this.signing || this.isAdminUser || !this.isLoggedIn) {
      return;
    }
    this.signing = true;
    this.errorMessage = '';
    this.cdr.markForCheck();
    const filteredItems = (this.detailData.items || [])
      .filter(item => item.isChecked)
      .map(item => ({
        ...item,
        quantity: Number(item.quantity || 1)
      }));

    if (filteredItems.length < 1) {
      alert('Vui lòng chọn ít nhất một kho hàng để ký hợp đồng.');
      this.signing = false;
      this.cdr.markForCheck();
      return;
    }

    const payload = {
      id: this.detailData.id,
      title: this.detailData.title,
      warehouseName: this.detailData.warehouseName,
      items: filteredItems,
      // totalRevenue: this.totalRevenue,
      // totalWholesale: this.totalWholesale,
      // totalProfit: this.totalProfit
    };
    this.stockService.contract(payload).subscribe({
      next: (res: any) => {
        if (res?.message === 'MONEY_NOT_ENOUGH') {
          this.signing = false;
          this.cdr.markForCheck();
          alert('Số dư không đủ để ký hợp đồng. Vui lòng nạp thêm tiền vào tài khoản.');
          return;
        }
        this.headerService.requestRefresh();
        this.contractSigned.emit(payload);
        this.closeContractModal();
        this.signing = false;
        this.cdr.markForCheck();
        if (this.detailData.id) {
          this.loadData(this.detailData.id);
        }
        alert('Đăng ký hợp đồng thành công.');
      },
      error: (err) => {
        this.signing = false;
        console.error('Lỗi khi ký hợp đồng:', err);
        const errorMessage = err?.error?.message || err?.message || 'Không thể ký hợp đồng. Vui lòng thử lại.';
        alert(errorMessage);
        this.cdr.markForCheck();
      },
    });
  }

  getPreviewItems(itemIndex: number): PreviewItem[] {
    return (this.existingMediaByItem[itemIndex] || []).map((url, index) => ({
      preview: url,
      name: `Tệp ${index + 1}`,
      type: this.detectMediaType(url),
    }));
  }

  getActivePreview(itemIndex: number): PreviewItem | null {
    const previewItems = this.getPreviewItems(itemIndex);
    if (!previewItems.length) return null;
    const activeIndex = this.activePreviewIndexByItem[itemIndex] || 0;
    if (activeIndex < 0 || activeIndex >= previewItems.length) {
      return previewItems[0];
    }
    return previewItems[activeIndex];
  }

  setActivePreview(itemIndex: number, previewIndex: number): void {
    const previewItems = this.getPreviewItems(itemIndex);
    if (previewIndex < 0 || previewIndex >= previewItems.length) return;

    this.activePreviewIndexByItem[itemIndex] = previewIndex;
    this.cdr.markForCheck();
  }

  onSwipeLeft(itemIndex: number): void {
    const currentIndex = this.activePreviewIndexByItem[itemIndex] || 0;
    const previewItems = this.getPreviewItems(itemIndex);
    const nextIndex = (currentIndex + 1) % previewItems.length;
    this.setActivePreview(itemIndex, nextIndex);
  }

  onSwipeRight(itemIndex: number): void {
    const currentIndex = this.activePreviewIndexByItem[itemIndex] || 0;
    const previewItems = this.getPreviewItems(itemIndex);
    const prevIndex = currentIndex === 0 ? previewItems.length - 1 : currentIndex - 1;
    this.setActivePreview(itemIndex, prevIndex);
  }

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('vi-VN').format(value || 0);
  }

  trackByIndex(index: number): number {
    return index;
  }

  private detectMediaType(url: string): string {
    const lower = (url || '').toLowerCase();
    if (/\.(mp4|webm|ogg|mov|m4v)(\?|$)/.test(lower)) {
      return 'video/mp4';
    }
    return 'image/jpeg';
  }

  private safeJoinUrl(base: string, path: string): string {
    if (!base) return path || '';
    if (!path) return base;
    if (/^https?:\/\//i.test(path)) return path;
    return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
  }

  private normalizeUploadPath(rawPath: string): string {
    if (!rawPath) return '';
    let normalized = rawPath.replace(/\\/g, '/');
    const marker = '/uploads/';
    const markerIndex = normalized.lastIndexOf(marker);
    if (markerIndex !== -1) {
      normalized = normalized.substring(markerIndex + 1);
    }
    return normalized.replace(/^\/+/, '');
  }

  private buildImageUrl(path: string): string {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    return this.safeJoinUrl(environment.apiUrl, this.normalizeUploadPath(path));
  }

  onQuantityChange(event: any, index: number): void {
    const numericValue = event.target.value.replace(/[^0-9]/g, '');
    const qty = numericValue ? Number(numericValue) : 1;
    const items = [...this.detailData.items];
    items[index] = {
      ...items[index],
      quantity: qty
    };
    this.detailData.items = items;
    this.cdr.markForCheck();
  }

  onFormattedNumberInput(event: any, index: number, field: string): void {
    const value = event.target.value.replace(/[^0-9]/g, '');
    const num = value ? Number(value) : null;
    this.detailData.items[index] = {
      ...this.detailData.items[index],
      [field]: num
    };
    this.cdr.markForCheck();
  }
  getItemWholesale(item: StockDetailItem): number {
    const revenue = this.getItemRevenue(item);
    return revenue * 0.9; // hoặc dùng item.wholesaleTotal nếu backend trả sẵn
  }
  getItemProfit(item: StockDetailItem): number {
    return this.getItemRevenue(item) - this.getItemWholesale(item);
  }
  getItemRevenue(item: StockDetailItem): number {
    const quantity = Number(item.quantity || 1);
    const retailPrice = Number(item.retailPrice || 1);
    return quantity * retailPrice;
  }
  getTotalRevenue(): number {
  return (this.detailData?.items || []).reduce((sum, item) => {
    return sum + this.getItemRevenue(item);
  }, 0);
}

getTotalWholesale(): number {
  return (this.detailData?.items || []).reduce((sum, item) => {
    return sum + this.getItemWholesale(item);
  }, 0);
}

getTotalProfit(): number {
  return this.getTotalRevenue() - this.getTotalWholesale();
}
}
